/* Good Morning footer (sections/good-morning-footer.liquid).
   On mobile the columns are an accordion with one column open at a time; on wider
   screens every column is shown and the headings are not toggles. A custom element,
   so theme editor section reloads re-run connectedCallback and disconnectedCallback
   removes the listeners. */
(function () {
  if (customElements.get('gm-footer')) return;

  var MOBILE_QUERY = '(max-width: 860px)';

  class GmFooter extends HTMLElement {
    connectedCallback() {
      this.media = window.matchMedia(MOBILE_QUERY);
      this.onClick = this.handleClick.bind(this);
      this.onMediaChange = this.sync.bind(this);
      this.onCountryChange = this.handleCountryChange.bind(this);
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onCountryChange);
      this.media.addEventListener('change', this.onMediaChange);
      this.classList.add('is-ready');
      this.sync();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onCountryChange);
      if (this.media) this.media.removeEventListener('change', this.onMediaChange);
    }

    // The country picker submits the localization form as soon as a country is chosen.
    handleCountryChange(event) {
      var select = event.target.closest('[data-gmf-country]');
      if (select && select.form) select.form.submit();
    }

    heads() {
      return Array.prototype.slice.call(this.querySelectorAll('.gmf__head'));
    }

    listFor(head) {
      var id = head.getAttribute('aria-controls');
      return id ? document.getElementById(id) : null;
    }

    setOpen(head, isOpen) {
      var list = this.listFor(head);
      head.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (list) list.classList.toggle('is-open', isOpen);
    }

    // Desktop shows every column; mobile starts with all of them closed.
    sync() {
      var isMobile = this.media.matches;
      this.heads().forEach(function (head) {
        if (isMobile) {
          head.removeAttribute('tabindex');
          head.removeAttribute('aria-disabled');
          this.setOpen(head, false);
        } else {
          head.setAttribute('tabindex', '-1');
          head.setAttribute('aria-disabled', 'true');
          this.setOpen(head, true);
        }
      }, this);
    }

    handleClick(event) {
      var head = event.target.closest('.gmf__head');
      if (!head || !this.media.matches) return;
      var willOpen = head.getAttribute('aria-expanded') !== 'true';
      this.heads().forEach(function (other) {
        this.setOpen(other, other === head ? willOpen : false);
      }, this);
    }
  }

  customElements.define('gm-footer', GmFooter);
})();
